import axios from "axios";
import HttpHelper from "../helper/HttpHelper";

class AvgService {
  create(payload) {
    return axios.post(
      HttpHelper.API_URL + "/averages",
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  getAll(payload) {
    return axios.get(
      HttpHelper.API_URL + "/averages",
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  getOne(id, payload) {
    return axios.get(
      HttpHelper.API_URL + "/averages/" + id,
      { params: payload },
      HttpHelper.getHeader()
    );
  }

  update(id, payload) {
    return axios.put(
      HttpHelper.API_URL + "/averages/" + id,
      payload,
      HttpHelper.getAuthHeader()
    );
  }

  delete(id) {
    return axios.delete(
      HttpHelper.API_URL + "/averages/" + id,
      HttpHelper.getAuthHeader()
    );
  }
}

export default AvgService = new AvgService();
